import { Divider, Card, Button, Popconfirm } from "antd";
import { SaveOutlined, DeleteOutlined } from "@ant-design/icons";
import Details from "./details";
import Photos from "./photos";
import Editor from "./editor";

export default function EditEntry({ data, loading, form, onDelete }) {
  return (
    <Card bordered={false}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-2">
        <div className="col-span-12">
          <Details />
        </div>
        <div className="col-span-12">
          <Photos form={form} />
        </div>
        <div className="col-span-12">
          <Editor form={form} />
        </div>
      </div>
      <Divider />
      <div className="flex flex-wrap justify-between items-center">
        <Button
          loading={loading}
          type="primary"
          icon={<SaveOutlined />}
          htmlType="submit"
        >
          Save
        </Button>
        <Popconfirm
          okText="Yes, delete"
          title="Delete wine?"
          description="Product will be deleted, you won't be able to restore it."
          onConfirm={onDelete}
        >
          <Button
            loading={loading}
            type="text"
            icon={<DeleteOutlined />}
            danger
          >
            Delete Wine
          </Button>
        </Popconfirm>
      </div>
    </Card>
  );
}
